import React from "react";

import { Redirect } from "react-router-dom";

export type RedirectUserSettingsProps = {};

export const RedirectUserSettings: React.FC<RedirectUserSettingsProps> = () => (
  <Redirect to="/settings" />
);
